import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { RootState, AppDispatch } from "./store"
import { NavigateOptions, useLocation } from "react-router"
import { useNavigationContext } from "../features/navigation/NavigationContext"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppNavigate = () => {
  const { navigate } = useNavigationContext()
  const location = useLocation()

  const stripDomain = (url: string) => {
    try {
      const parsedUrl = new URL(url)
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
    } catch {
      return url
    }
  }

  return (to: string, options?: NavigateOptions) => {
    const target = stripDomain(to)
    const hasHashInTarget = /#/.test(target)
    const currentPathWithSearch = location.pathname + location.search
    if (!hasHashInTarget) {
      if (target === location.pathname || target === currentPathWithSearch) {
        const preserved = currentPathWithSearch + location.hash
        navigate(preserved, options)
        return
      }
    }
    navigate(target, options)
  }
}
